import { Controller } from "@hotwired/stimulus"

// Handles agreement settings changes with targeted field updates
// Sends JSON request and updates only the affected field spans in the document
export default class extends Controller {
  static targets = ["select"]

  async submit(event) {
    event.preventDefault()

    const form = this.element
    const formData = new FormData(form)
    const select = event.target
    const fieldName = select.name.match(/\[(\w+)\]$/)?.[1]

    try {
      const response = await fetch(form.action, {
        method: form.method || 'PATCH',
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
        },
        body: formData
      })

      const data = await response.json()

      if (data.success && data.updated_fields) {
        this.updateFields(data.updated_fields)
      } else if (data.error) {
        console.error('Settings update failed:', data.error)
      }
    } catch (error) {
      console.error('Settings update error:', error)
    }
  }

  updateFields(updatedFields) {
    Object.entries(updatedFields).forEach(([fieldKey, fieldData]) => {
      // Find all spans with this field key
      const spans = document.querySelectorAll(`[data-field="${fieldKey}"]`)

      spans.forEach(span => {
        // Update the displayed value
        // Convert newlines and <br> tags for display
        let displayValue = fieldData.formatted_value || ''
        displayValue = displayValue
          .replace(/\n/g, '<br>')
          .replace(/&lt;br&gt;/g, '<br>')

        span.innerHTML = displayValue

        // Update the raw value attribute if present
        if (span.hasAttribute('data-raw-value')) {
          span.setAttribute('data-raw-value', fieldData.raw_value || '')
        }

        // Update empty state
        if (fieldData.formatted_value) {
          span.classList.remove('empty')
          span.removeAttribute('data-empty')
        } else {
          span.classList.add('empty')
          span.setAttribute('data-empty', 'true')
        }

        // Add a brief highlight to show the field was updated
        span.classList.add('field-updated')
        setTimeout(() => span.classList.remove('field-updated'), 1500)
      })
    })
  }
}
